import axios from 'Src/helpers/api/axiosInstance';

export type PasswordRequestPurpose = 'PASSWORD_RESET' | 'PASSWORD_SETUP';

export function resetRequestPassword(email: string, purpose: PasswordRequestPurpose = 'PASSWORD_RESET') {
  const data = {
    email,
    purpose
  };
  const config = {};

  return axios.post(`${window.apiBase}/public/passwords/resetRequest`, data, config).then(response => {
    return response.data;
  });
}

export function resetPassword(password: string, secretKey: string) {
  const data = {
    newPassword: password,
    secretKey: secretKey
  };
  const config = {};

  return axios.post(`${window.apiBase}/public/passwords/reset`, data, config).then(response => {
    return response.data;
  });
}

export function validateResetPasswordToken(secretKey: string) {
  return axios.post(`${window.apiBase}/public/passwords/reset/validate`, { secretKey }).then(response => {
    return response.data;
  });
}
